import { ContainerOverlay } from 'components/Container/ContainerOverlay';
import GenericError from 'pages/Authorize/Errors/GenericError';
import { useEffect, useRef } from 'react';
import { useTrackConversionStep } from '../../../services/track-conversion';
import { useTrackConversionError } from 'services/track-conversion';

export const AuthFallbackThresholdError = ({
  providerName,
  onNext,
}: {
  providerName: string;
  onNext: () => void;
}) => {
  const trackConversion = useTrackConversionStep();
  const mounted = useRef(false);

  const trackConversionError = useTrackConversionError();

  useEffect(() => {
    if (!mounted.current) {
      trackConversion({
        action: 'threshold_error_displayed',
      });
      mounted.current = true;
    }
  }, [trackConversion]);

  return (
    <ContainerOverlay>
      <GenericError
        buttonLabel="Connect manually"
        isSecondaryButton
        title="Let's try this again"
        onClick={async () => {
          trackConversion({
            action: 'threshold_error_dismissed',
          });
          onNext();
        }}
      >
        We&apos;re currently experiencing connection issues with {providerName}.
        Please try to connect manually.
      </GenericError>
    </ContainerOverlay>
  );
};
